export default __webpack_public_path__ + "static/lbr-873db3584388ad0d03c4b8174944fba3.png";